export default __webpack_public_path__ + "static/case-3-a510ba946ad45e4b48d9caa6da672180.webp";